import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CountdownService {
  
  constructor( ) { }

  private readonly countdownImssSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  private readonly countdownNssSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  private readonly countdownIsssteSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  public imssNameCountdowmn: string = "imssHistoryTimmer";
  public nssNameCountdowmn: string = "nssTimmer";
  public isssteNameCountdowmn: string = "isssteHistoryTimmer";

  /** Method for create the count by initial time for every second */
  public creatCountdown(initialTimeSeconds: number): Observable<number> {
    return timer(0, 1000).pipe(
      map(second => initialTimeSeconds - second),
      takeWhile(second => second >= 0)
    );
  }

  /** Init the countdown, by our number selected */
  public startCountdown(initialTimeSeconds: number, name: string) {
    console.log("Inicia countdown: "+name+" tiempo: "+initialTimeSeconds);
    localStorage.setItem(name, initialTimeSeconds+"");
    this.creatCountdown(initialTimeSeconds).subscribe(second => {
      localStorage.setItem(name, second+"");
      //console.log(second);
      if (second === 0) {
        // Here we can to do additionals actions when the countdown is zero
        console.log('¡Countdown '+name+' finalizado!');
        localStorage.removeItem(name);
        if(name === this.imssNameCountdowmn) {
          this.countdownImssSubject?.next(second);
        }
        if(name === this.nssNameCountdowmn) {
          this.countdownNssSubject?.next(second);
        }
        if(name === this.isssteNameCountdowmn) {
          this.countdownIsssteSubject?.next(second);
        }
      }
    });
    
  }
  /** Method for get the value of history imss countdown */
  public getTiempoRestanteImss(): Observable<number> {
    return this.countdownImssSubject.asObservable();
  }
  /** Method for get the value of nss countdown */
  public getTiempoRestanteNss(): Observable<number> {
    return this.countdownNssSubject.asObservable();
  }
  /** Method for get the value of history issste countdown */
  public getTiempoRestanteIssste(): Observable<number> {
    return this.countdownIsssteSubject.asObservable();
  }

  public removeCountdown(nameCountdowmn: string): void {
    localStorage.removeItem(nameCountdowmn);
  }

}
